// extracted by mini-css-extract-plugin
export var asterisk = "LegalTerm-module--asterisk--502ff";
export var checkboxClass = "LegalTerm-module--checkboxClass--3cfb8";
export var checked = "LegalTerm-module--checked--d7595";
export var label = "LegalTerm-module--label--64275";
export var labelCheckboxClass = "LegalTerm-module--labelCheckboxClass--4086b";
export var labelCheckboxClassStatement = "LegalTerm-module--labelCheckboxClassStatement--d791e";